import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Tracker from '@openreplay/tracker';
import trackerAssist from '@openreplay/tracker-assist';

// Check if browser supports required APIs and DoNotTrack is not enabled
if (typeof window !== 'undefined' && 
    !navigator.doNotTrack && 
    navigator.doNotTrack !== '1' && 
    window.performance && 
    window.MutationObserver) {
  try {
    const tracker = new Tracker({
      projectKey: "b7ToH7SYCth39CZnZHtV",
      ingestPoint: "https://orly.insureco.io/ingest",
    });
    tracker.use(trackerAssist());
    tracker.start();
  } catch (error) {
    console.warn('OpenReplay initialization failed:', error.message);
  }
} else {
  console.log('OpenReplay skipped: Browser does not support required APIs or DoNotTrack is enabled');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);